import { create } from 'zustand';

export const useTaskCreateStore = create((set) => ({
  isOpen: false,
  payload: {},
  callback: null, //
  openTaskCreate: (payload,callback=null) => set({ isOpen: true, payload,callback }),
    close: (result) => set((state) => {
    // Call callback if exists, and clear everything
    if (state.callback) state.callback(result);
    return { isOpen: false, payload: {}, callback: null };
  }),
}));
export const openTaskCreate = (payload) => {
  const store = useTaskCreateStore.getState();
  store.openTaskCreate(payload);
};

export const closeTaskCreate = () => {
  const store = useTaskCreateStore.getState();
  store.close();
};